import React from "react";

const COLUMN_DATA = [
  {
    dataIndex: "id",
    key: "id",
    title: "Name",
    className: "w-full",
  },
  {
    dataIndex: "flags",
    key: "flags",
    title: "Flags",
    className: "flex-none w-28",
  },
  {
    dataIndex: "card",
    key: "card",
    title: "Cardinality",
    className: "flex-none w-28",
  },
  {
    dataIndex: "type",
    key: "type",
    title: "Type",
    className: "flex-none w-40",
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description & Constraints",
    className: "flex-none w-1/3",
  },
];

const FLAGS = {
  isSummary: {
    tooltip: "This element is included in summaries",
    content: <span>&Sigma;</span>,
  },
  isModifier: {
    tooltip: "This element is a modifier element",
    content: <span>?!</span>,
  },
  mustSupport: {
    tooltip: "This element must be supported",
    content: (
      <div>
        <span className="bg-red-600 font-extralight text-center px-1">S</span>
      </div>
    ),
  },
  condition: {
    tooltip: "This element has or is affected by some invariants (ait-1,ait-2)",
    content: <span>&Iota;</span>,
  },
};

export { COLUMN_DATA, FLAGS };
